import React from 'react'
import './Item.css'
import { Link } from 'react-router-dom'

const Item = (props) => {
  const handleImageError = (e) => {
    e.target.src = '/images/placeholder.jpg';
  };

  // Calculate discount percentage if not provided as prop
  const calculateDiscountPercentage = () => {
    // If discountPercentage is already passed as prop, use it
    if (props.discountPercentage !== undefined) {
      return props.discountPercentage;
    }
    
    // Otherwise calculate it from prices
    const oldPrice = parseFloat(props.old_price) || 0;
    const newPrice = parseFloat(props.new_price) || 0;
    
    if (oldPrice > 0 && newPrice > 0 && newPrice < oldPrice) {
      return Math.round(((oldPrice - newPrice) / oldPrice) * 100);
    }
    
    return 0;
  };

  const discountPercentage = calculateDiscountPercentage();

  return (
    <Link to={`/product/${props.id}`} className="item-link">
      <div className='item'>
        {/* Discount Badge */}
        {discountPercentage > 0 && (
          <div className="discount-badge">
            -{discountPercentage}% OFF
          </div>
        )}
        
        <img 
          src={props.image} 
          alt={props.name}
          onError={handleImageError}
        />
        <p>{props.name}</p>
        <div className="item-prices">
          <div className="item-price-new">Rs {props.new_price}</div>
          {props.old_price && parseFloat(props.old_price) > parseFloat(props.new_price) ? (
            <div className="item-price-old">Rs {props.old_price}</div>
          ) : null}
        </div>
      </div>
    </Link>
  );
};

export default Item;
